// ============================================================================
// post-client-mod -- Markdown 样式常量
//
// 用于 <style> 标签注入到页面，美化 Markdown 渲染后的 HTML 元素。
// ============================================================================
export const MARKDOWN_CSS = `
  .markdown-body { font-size: 16px; line-height: 1.8; color: #333; }
  .markdown-body h1 { font-size: 2em; font-weight: 700; margin: 0.8em 0 0.4em; line-height: 1.3; color: #1a1a1a; }
  .markdown-body h2 { font-size: 1.5em; font-weight: 600; margin: 0.8em 0 0.4em; line-height: 1.35; border-bottom: 1px solid #eaeaea; padding-bottom: 0.3em; color: #1a1a1a; }
  .markdown-body h3 { font-size: 1.25em; font-weight: 600; margin: 0.8em 0 0.4em; line-height: 1.4; color: #1a1a1a; }
  .markdown-body h4 { font-size: 1.1em; font-weight: 600; margin: 0.8em 0 0.4em; color: #1a1a1a; }
  .markdown-body p { margin: 0 0 1em 0; }
  .markdown-body a { color: #6366f1; text-decoration: none; }
  .markdown-body a:hover { text-decoration: underline; }
  .markdown-body ul, .markdown-body ol { padding-left: 2em; margin: 0 0 1em 0; }
  .markdown-body li { margin: 0.25em 0; }
  .markdown-body blockquote { border-left: 4px solid #dfe2e5; padding: 0 1em; color: #6a737d; margin: 0 0 1em 0; }
  .markdown-body code { background-color: #f6f8fa; padding: 0.2em 0.4em; border-radius: 3px; font-size: 0.9em; font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace; }
  .markdown-body pre { background-color: #f6f8fa; padding: 16px; border-radius: 6px; overflow: auto; margin: 0 0 1em 0; }
  .markdown-body pre code { background: none; padding: 0; border-radius: 0; font-size: 0.875em; }
  .markdown-body table { border-collapse: collapse; width: 100%; margin: 0 0 1em 0; }
  .markdown-body th, .markdown-body td { border: 1px solid #dfe2e5; padding: 8px 12px; text-align: left; }
  .markdown-body th { background-color: #f6f8fa; font-weight: 600; }
  .markdown-body img { max-width: 100%; height: auto; border-radius: 6px; }
  .markdown-body hr { border: none; border-top: 1px solid #eaeaea; margin: 2em 0; }
  .markdown-body strong { font-weight: 600; }
  .markdown-body em { font-style: italic; }
  .markdown-body del { text-decoration: line-through; color: #999; }
`;
//# sourceMappingURL=markdown-styles.js.map